import React, { Fragment, useEffect, useRef, useState } from "react";
import AvailableColour from './productAIFormComponents/AvailableColour';
import AvailableIn from './productAIFormComponents/AvailableIn';
import AvailableDifferenceFabric from './productAIFormComponents/AvailableDifferenceFabric';
import AvailableLengthTable from './productAIFormComponents/AvailableLengthTable';
import AvailableFitTable from './productAIFormComponents/AvailableFitTable';
import FabricTable from './productAIFormComponents/FabricTable';
import TrimmingsTable from './productAIFormComponents/TrimmingsTable';
import WashCareTable from './productAIFormComponents/WashCareTable';
import ColourTable from './productAIFormComponents/ColourTable';
import OccassionTable from './productAIFormComponents/OccassionTable';

import {
    Button,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row, 
} from "reactstrap";


import Select, { components } from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
    setProductAIDialog,
    getAIProductView,
    updateAIProductDetails,
    getAiTagsBasedOnImage,
    getAiFromCGPortal,
} from "../../store/prodcutSlice";
import PreLoader from "../../../../share-components/ui/preLoader";
import LogActivity from "../../../log";
import { toast } from "react-toastify";
import "./styles/productAIForm.scss";


const ProductAIForm = (props) => {
    // Image popup state for header image
    const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
    const [popupImageIndex, setPopupImageIndex] = useState(0);

    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const productState = useSelector(({ product }) => product.product.productAIDialogProps);
    const productId = productState.data ? productState.data.id : "";
    const [submitBtnDisable, setSubmitBtnDisable] = useState(false);
    const [aiTagsBasedOnImageBtnDisable, setAiTagsBasedOnImageBtnDisable] = useState(false);
    const [aiSyncFromCGPortalBtnDisable, setAiSyncFromCGPortalBtnDisable] = useState(false);

    const formBtnDisable = () => {
        return submitBtnDisable || aiTagsBasedOnImageBtnDisable || aiSyncFromCGPortalBtnDisable;
    }

    const [modalTitle, setModalTitle] = useState("AI Form");
    const [productImages, setProductImages] = useState([]);

    const [settingPatternTypes, setSettingPatternTypes] = useState([]);
    const [settingPatternTypeItems, setSettingPatternTypeItems] = useState([]);
    const [settingColourTypes, setSettingColourTypes] = useState([]);
    const [settingColourFamilies, setSettingColourFamilies] = useState([]);
    const [settingMainSolidColours, setSettingMainSolidColours] = useState([]);
    const [settingColours, setSettingColours] = useState([]);
    const [settingFabricTypes, setSettingFabricTypes] = useState([]);
    const [settingMainFabrics, setSettingMainFabrics] = useState([]);
    const [settingSubFabrics, setSettingSubFabrics] = useState([]);
    const [settingCompositions, setSettingCompositions] = useState([]);
    const [settingTrimmings, setSettingTrimmings] = useState([]);
    const [settingSubTrimmings, setSettingSubTrimmings] = useState([]);
    const [settingWashCares, setSettingWashCares] = useState([]);
    const [settingSubWashCares, setSettingSubWashCares] = useState([]);
    const [settingAvailableInTypes, setSettingAvailableInTypes] = useState([]);
    const [settingAvailableLengthTypes, setSettingAvailableLengthTypes] = useState([]);
    const [settingAvailableFitTypes, setSettingAvailableFitTypes] = useState([]);

    // Additional select option states for new fields
    const [settingAboutTheFits, setSettingAboutTheFits] = useState([]);
    const [settingSleeveTypes, setSettingSleeveTypes] = useState([]);
    const [settingSleeveLengths, setSettingSleeveLengths] = useState([]);
    const [settingNeckTypes, setSettingNeckTypes] = useState([]);
    const [settingHemTypes, setSettingHemTypes] = useState([]);
    const [settingTrueToSizeOptions, setSettingTrueToSizeOptions] = useState([]);


    const [settingSpecialFeatures, setSettingSpecialFeatures] = useState([]);
    const [settingSustainabilityInfo, setSettingSustainabilityInfo] = useState([]);

    // New select option states for additional product info
    const [settingProductTypes, setSettingProductTypes] = useState([]);
    const [settingProductCategories, setSettingProductCategories] = useState([]);
    const [settingProductSubCategories, setSettingProductSubCategories] = useState([]);
    const [settingStyles, setSettingStyles] = useState([]);
    const [settingCatStyles, setSettingCatStyles] = useState([]);
    const [settingDressLengths, setSettingDressLengths] = useState([]);
    const [settingOccassions, setSettingOccassions] = useState([]);
    const [settingSubOccassions, setSettingSubOccassions] = useState([]);
    const [settingSeasons, setSettingSeasons] = useState([]);
    const [settingCommodities, setSettingCommodities] = useState([]);


    const [disabledInputs, setDisabledInputs] = useState({
        colours: [],
    });

    // Dress Length disable rule (based on Product Category = Clothing)
    const [isDressLengthDisabled, setIsDressLengthDisabled] = useState(false);

    const isClothingCategory = (categoryId) => {
        if (!categoryId) return false;
        const catObj = (settingProductCategories || []).find(c => String(c.id) === String(categoryId));
        return (catObj?.name || "").trim().toLowerCase() === "clothing";
    };

    const applyDressLengthRule = (categoryId) => {
        const shouldDisable = isClothingCategory(categoryId);

        if (shouldDisable) {
            setValue("dress_length", "");     // make it empty
            trigger("dress_length");
        }

        setIsDressLengthDisabled(shouldDisable);
    };

    const closDialog = () => {
        dispatch(setProductAIDialog({ props: false }));
        setLoading(true);
    }

    // Sync handler to re-fetch product AI view and update header/images
    const handleAiTagsBasedOnImage = (imageId) => {
        if (!productId) return;
        setAiTagsBasedOnImageBtnDisable(true);
        dispatch(getAiTagsBasedOnImage({product_id: productId, image_id: imageId})).then(res => {
            if (!res.error) {
                const selectedValues = res.payload;
                
                if (selectedValues.pattern_type !== undefined || selectedValues.pattern_type !== null) setValue("pattern_type", selectedValues.pattern_type);
                if (selectedValues.product_category !== undefined && selectedValues.product_category !== null) {
                    setValue("product_category", selectedValues.product_category);
                    applyDressLengthRule(selectedValues.product_category);
                }
                if (selectedValues.product_sub_category !== undefined || selectedValues.product_sub_category !== null) setValue("product_sub_category", selectedValues.product_sub_category);
                if (selectedValues.styles !== undefined || selectedValues.styles !== null) setValue("styles", selectedValues.styles);
                if (selectedValues.dress_length !== undefined && selectedValues.dress_length !== null) {
                    // If category is Clothing, do NOT apply dress_length from AI
                    const categoryId = selectedValues.product_category ?? getValues("product_category");
                    if (!isClothingCategory(categoryId)) {
                        setValue("dress_length", selectedValues.dress_length);
                        trigger("dress_length");
                    }
                }
                if (selectedValues.sleeve_type !== undefined || selectedValues.sleeve_type !== null) setValue("sleeve_type", selectedValues.sleeve_type);
                if (selectedValues.sleeve_length !== undefined || selectedValues.sleeve_length !== null) setValue("sleeve_length", selectedValues.sleeve_length);
                if (selectedValues.neck_type !== undefined || selectedValues.neck_type !== null) setValue("neck_type", selectedValues.neck_type);
                if (selectedValues.hem_type !== undefined || selectedValues.hem_type !== null) setValue("hem_type", selectedValues.hem_type);
                if (selectedValues.special_features !== undefined || selectedValues.special_features !== null) setValue("special_features", selectedValues.special_features);
                
                if (selectedValues.colours !== undefined || selectedValues.colours !== null) setColourRows(selectedValues.colours);
                if (selectedValues.occassions !== undefined || selectedValues.occassions !== null) setOccassionRows(selectedValues.occassions);
                
                trigger("product_category");
                trigger("product_sub_category");
                
                toast.success("Product synced", { position: toast.POSITION.TOP_RIGHT });
            } else {
                toast.error("Failed to sync product", { position: toast.POSITION.TOP_RIGHT });
            }
            setAiTagsBasedOnImageBtnDisable(false);
        });
    }

    // Sync handler to re-fetch product AI view and update header/images
    const handleSyncFromCGPortal = () => {
        if (!productId) return;
        setAiSyncFromCGPortalBtnDisable(true);
        dispatch(getAiFromCGPortal({product_id: productId})).then(res => {
            if (!res.error) {
                const selectedValues = res.payload.selected_values;
                const settings = res.payload.settings;

                setSettingFabricTypes(settings.fabric_types || []);
                setSettingMainFabrics(settings.main_fabrics || []);
                setSettingSubFabrics(settings.sub_fabrics || []);
                setSettingCompositions(settings.compositions || []);
                setSettingTrimmings(settings.trimmings || []);
                setSettingSubTrimmings(settings.sub_trimmings || []);
                setSettingWashCares(settings.wash_cares || []);
                setSettingSubWashCares(settings.wash_care_details || []);
                setSettingCommodities(settings.commodities || []);

                setFabricRows(selectedValues ? selectedValues.fabrics : []);
                setTrimmingRows(selectedValues ? selectedValues.trimmings : []);
                setWashCareRows(selectedValues ? selectedValues.wash_cares : []);
                setValue("commodities", selectedValues ? selectedValues.commodities : '');
                
                toast.success("Successfully product synced from CG Portal", { position: toast.POSITION.TOP_RIGHT });
            } else {
                toast.error("Failed to sync product", { position: toast.POSITION.TOP_RIGHT });
            }
            setAiSyncFromCGPortalBtnDisable(false);
        });
    }
    
    // Table state for Also Available in Length
    const [availableLengthRows, setAvailableLengthRows] = useState([
        { length_type: '', lengths: [] }
    ]);
    
    // Table state for Also Available in Fit
    const [availableFitRows, setAvailableFitRows] = useState([
        { fit_type: '', fits: [] }
    ]);

    // Table state for Also Available In
    const [availableInRows, setAvailableInRows] = useState([
        { type: '', ins: [] }
    ]);

    
    // Fabric Table State and Handlers
    const [colourRows, setColourRows] = useState([
        { colour: '', main_solid_colour: '', colour_family: '' }
    ]);

    // Fabric Table State and Handlers
    const [fabricRows, setFabricRows] = useState([
        { fabric_type: '', main_fabric: '', sub_fabric: [] }
    ]);
    
    // Trimmings Table State and Handlers
    const [trimmingRows, setTrimmingRows] = useState([
        { trimming: '', sub_trimming: [] }
    ]);
    
    // Wash Care Table State and Handlers
    const [washCareRows, setWashCareRows] = useState([
        { wash_care: '', wash_care_details: [] }
    ]);
    
    // Wash Care Table State and Handlers
    const [occassionRows, setOccassionRows] = useState([
        { occasion_id: '', occasion_sub_ids: [] }
    ]);


    useEffect(() => {
        setLoading(true);
        if (productId) {
            dispatch(getAIProductView(productId)).then(res => {
                if (!res.error) {
                    setModalTitle(`AI Form - ${res.payload.title || 'New Product'}`);
                    setProductImages(res.payload.images || []);

                    const selectedValues = res.payload.selected_values;
                    setValue("pattern_type", selectedValues ? selectedValues.pattern_type : '');
                    setValue("main_print_type", selectedValues ? selectedValues.main_print_type : '');

                    trigger("pattern_type");
                    trigger("main_print_type");
                    trigger("colour_type");
                    trigger("main_solid_colour");
                    trigger("colour_family");
                    trigger("colours");

                    // Additional Product Info
                    setValue("about_the_fits", selectedValues ? selectedValues.about_the_fits : []);
                    setValue("sleeve_type", selectedValues ? selectedValues.sleeve_type : '');
                    setValue("sleeve_length", selectedValues ? selectedValues.sleeve_length : '');
                    setValue("neck_type", selectedValues ? selectedValues.neck_type : '');
                    setValue("hem_type", selectedValues ? selectedValues.hem_type : '');                    
                    setValue("true_to_size", selectedValues ? selectedValues.true_to_size : '');
                    setValue("available_length", selectedValues ? selectedValues.available_length : '');
                    setValue("available_fit", selectedValues ? selectedValues.available_fit : '');
                    setValue("special_features", selectedValues ? selectedValues.special_features : '');
                    setValue("sustainability_records", selectedValues ? selectedValues.sustainability_records : '');

                    // New additional product info fields
                    setValue("product_type", selectedValues ? selectedValues.product_type : '');
                    setValue("product_category", selectedValues ? selectedValues.product_category : '');
                    setValue("product_sub_category", selectedValues ? selectedValues.product_sub_category : '');
                    setValue("styles", selectedValues ? selectedValues.styles : '');
                    setValue("dress_length", selectedValues ? selectedValues.dress_length : '');
                    setValue("seasons", selectedValues ? selectedValues.seasons : '');
                    setValue("commodities", selectedValues ? selectedValues.commodities : '');
                    setValue("available_colours", selectedValues ? selectedValues.available_colours : '');
                    setValue("available_difference_fabrics", selectedValues ? selectedValues.available_difference_fabrics : '');

                    // Disable inputs if selectedValues exist for that field
                    setDisabledInputs({
                        colours: selectedValues && selectedValues.colours ? selectedValues.colours : [],
                    });
                    
                    setColourRows(selectedValues ? selectedValues.colours : []);
                    setFabricRows(selectedValues ? selectedValues.fabrics : []);
                    setTrimmingRows(selectedValues ? selectedValues.trimmings : []);
                    setWashCareRows(selectedValues ? selectedValues.wash_cares : []);
                    setOccassionRows(selectedValues ? selectedValues.occassions : []);
                    

                    const availableLengths = selectedValues ? selectedValues.available_lengths : [];
                    const availableFits = selectedValues ? selectedValues.available_fits : [];
                    const availableIns = selectedValues ? selectedValues.available_ins : [];

                    setAvailableLengthRows(availableLengths);
                    setAvailableFitRows(availableFits);
                    setAvailableInRows(availableIns);
                    
                    // Set settings data
                    const settings = res.payload.settings;
                    setSettingPatternTypes(settings.pattern_types);
                    setSettingColourTypes(settings.colour_types);
                    setSettingColourFamilies(settings.colour_families);
                    setSettingMainSolidColours(settings.main_colours);
                    setSettingColours(settings.colours);
                    setSettingFabricTypes(settings.fabric_types || []);
                    setSettingMainFabrics(settings.main_fabrics || []);
                    setSettingSubFabrics(settings.sub_fabrics || []);
                    setSettingTrimmings(settings.trimmings || []);
                    setSettingSubTrimmings(settings.sub_trimmings || []);
                    setSettingWashCares(settings.wash_cares || []);
                    setSettingSubWashCares(settings.wash_care_details || []);

                    // Set additional select options from settings
                    setSettingAboutTheFits(settings.fit_types || []);
                    setSettingSleeveTypes(settings.sleeve_types || []);
                    setSettingSleeveLengths(settings.sleeve_lengths || []);
                    setSettingNeckTypes(settings.neck_types || []);
                    setSettingHemTypes(settings.hem_types || []);                    
                    setSettingTrueToSizeOptions(settings.fit_size_conditions || []);
                    setSettingSpecialFeatures(settings.special_features || []);
                    setSettingSustainabilityInfo(settings.sustainability_records || []);

                    // Set new additional product info select options from settings
                    setSettingProductTypes(settings.product_types || []);
                    setSettingProductCategories(settings.product_categories || []);
                    setSettingProductSubCategories(settings.product_sub_categories || []);
                    setSettingStyles(settings.styles || []);
                    setSettingDressLengths(settings.dress_lengths || []);
                    setSettingOccassions(settings.occassions || []);
                    setSettingSubOccassions(settings.occassion_subs || []);
                    setSettingSeasons(settings.seasons || []);
                    setSettingCommodities(settings.commodities || []);

                    
                    setSettingAvailableLengthTypes(settings.dress_lengths || []);
                    setSettingAvailableFitTypes(settings.available_fit_types || []);
                    setSettingAvailableInTypes(settings.available_in_types || []);

                    let selectedPatternTypeItems = [];
                    if (selectedValues && selectedValues.pattern_type) {
                        const selectedPatternType = settings.pattern_types.find(type => type.id == selectedValues.pattern_type);
                        selectedPatternTypeItems = selectedPatternType ? selectedPatternType.items : [];
                    }
                    setSettingPatternTypeItems(selectedPatternTypeItems);
                    
                    setSettingCatStyles((settings.styles || [])?.filter(opt => opt.category_id === (selectedValues ? selectedValues.product_category : '')) || []);
                }
                setLoading(false);
            });
        }
    }, [productId]);

    const formRef = useRef();

    const defaultValues = {
        pattern_type: '',
        fabrics_has_duplicates: false, // existing
        trimmings_has_duplicates: false, // added default for trimmings
        about_the_fits: [], // default now an array for multi-select
    };

    const schema = yup.object().shape({
        // pattern_type: yup.string().required("Pattern Type is required field."),
    });

    const { handleSubmit, formState, reset, register, setValue, getValues, trigger, watch } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const watchedProductCategory = watch("product_category");

    // Enforce Dress Length rule whenever product_category changes (manual OR programmatic)
    useEffect(() => {
        applyDressLengthRule(watchedProductCategory);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchedProductCategory, settingProductCategories]);

    const watchedDressLength = watch("dress_length");

    // If Dress Length is disabled (category = Clothing), force it empty even if AI sets it later
    useEffect(() => {
        if (isDressLengthDisabled && watchedDressLength) {
            setValue("dress_length", "");
            trigger("dress_length");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDressLengthDisabled, watchedDressLength]);

    const { errors } = formState;

    // watch duplicate flags set by FabricTable and TrimmingsTable
    const fabricsHasDuplicates = watch("fabrics_has_duplicates", false);
    const trimmingsHasDuplicates = watch("trimmings_has_duplicates", false);
    const washCaresHasDuplicates = watch("wash_cares_has_duplicates", false);
    const availableInDuplicates = watch("available_ins_has_duplicates", false);
    const availableLengthsHasDuplicates = watch("available_lengths_has_duplicates", false);
    const availableFitDuplicates = watch("available_fits_has_duplicates", false);
 
    const onSubmitForm = (data) => {
        // block submit if duplicate fabric or trimming rows exist
        if (fabricsHasDuplicates || trimmingsHasDuplicates) {
            toast.error("Please remove duplicate fabric or trimming rows before submitting.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (washCaresHasDuplicates) {
            toast.error("Please remove duplicate wash care rows before submitting.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        // Also Available In (Mature, Modesty..)
        if (availableInDuplicates) {
            toast.error("Please remove duplicate wash care rows before submitting.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (availableLengthsHasDuplicates) {
            toast.error("Please remove duplicate available length rows before submitting.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (availableFitDuplicates) {
            toast.error("Please remove duplicate available fit rows before submitting.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const formData = getValues();
        setSubmitBtnDisable(true);
        dispatch(updateAIProductDetails({ ...formData, id: productId })).then(res => {
            if (!res.error) {
                toast.success(res.payload, { position: toast.POSITION.TOP_RIGHT });
                closDialog();
            }
            setSubmitBtnDisable(false);
        });
    }    


    return (
        <>
            <Modal className="modal-fullscreen product-ai-modal modal-dialog-centered modal-dialog-scrollable" {...productState.props} style={{ width: '100vw', height: '100vh', maxWidth: '100vw', maxHeight: '100vh', margin: 0, padding: '20px', top: 0, left: 0 }}>
                {!loading && <ModalHeader
                    toggle={() => { closDialog() }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        {productImages && productImages.length > 0 && (
                            <img
                                src={productImages[0].url}
                                alt={productImages[0].alt_text}
                                style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee', cursor: 'pointer' }}
                                onClick={() => setIsImagePopupOpen(true)}
                            />
                        )}
                        <span>{modalTitle}</span>
                    </div>
                </ModalHeader>}


                {loading && <ModalBody style={{ minHeight: '350px' }}>
                    <PreLoader withoutText={false}></PreLoader>
                </ModalBody>}


                {!loading && <ModalBody>
                    <div style={{position: 'fixed', top: '50%', zIndex: 1000, right:0}}>
                        <LogActivity className="modal-actitity-log" log="AI Form" id={productId}></LogActivity>
                    </div>

                    <Row>
                        <Col md="3" style={{ position: 'sticky', top: 0, alignSelf: 'flex-start', zIndex: 10, height: '100%' }}>
                            {/* Leftside - Display Product Image with slider, fixed position */}
                            <div style={{ position: 'relative', width: '100%', textAlign: 'center', paddingTop: 24 }}>
                                {productImages && productImages.length > 0 && (
                                    <>
                                        <img
                                            src={productImages[popupImageIndex].url}
                                            alt={productImages[popupImageIndex].alt_text}
                                            style={{ width: '100%', height: 'auto', borderRadius: 8, cursor: 'pointer', maxHeight: '60vh', objectFit: 'contain' }}
                                            onClick={() => setIsImagePopupOpen(true)}
                                        />
                                        {productImages.length > 1 && (
                                            <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, display: 'flex', justifyContent: 'space-between', width: '100%', pointerEvents: 'none' }}>
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    style={{ pointerEvents: 'auto', position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' }}
                                                    onClick={() => setPopupImageIndex((popupImageIndex - 1 + productImages.length) % productImages.length)}
                                                    disabled={productImages.length <= 1}
                                                >
                                                    <i className="fa fa-chevron-left" />
                                                </Button>
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    style={{ pointerEvents: 'auto', position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}
                                                    onClick={() => setPopupImageIndex((popupImageIndex + 1) % productImages.length)}
                                                    disabled={productImages.length <= 1}
                                                >
                                                    <i className="fa fa-chevron-right" />
                                                </Button>
                                            </div>
                                        )}
                                        <div style={{ marginTop: 8, color: '#888', fontSize: 14 }}>
                                            {popupImageIndex + 1} / {productImages.length}
                                        </div>
                            
                                        <Button color="success" className="mt-3" onClick={() => {handleAiTagsBasedOnImage(productImages[popupImageIndex].id)}} disabled={formBtnDisable() || !productId} title="Sync product data">
                                            {aiTagsBasedOnImageBtnDisable && <i className="fa fa-spinner fa-lg spinner mr-1" />} Sync
                                        </Button>
                            
                                        <Button color="primary" className="mt-3 ml-2" onClick={() => {handleSyncFromCGPortal()}} disabled={formBtnDisable() || !productId} title="Sync product data">
                                            {aiSyncFromCGPortalBtnDisable && <i className="fa fa-spinner fa-lg spinner mr-1" />} Sync from CG Portal
                                        </Button>
                                    </>
                                )}
                            </div>
                        </Col>
                        <Col md="">
                            <Form id="productAIForm" ref={formRef} onSubmit={handleSubmit(onSubmitForm)}>
                                <Row>
                                    {/* Pattern Type (single select) */}
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-label">Pattern Type</Label>
                                            <Select
                                                placeholder="Select Pattern Type"
                                                isDisabled={disabledInputs.pattern_type}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                getOptionValue={(option) => option.id}
                                                getOptionLabel={(option) => option.name}
                                                options={settingPatternTypes}
                                                className={errors.pattern_type ? "is-invalid" : ""}
                                                value={settingPatternTypes.find(opt => opt.id === (getValues("pattern_type") || '')) || null}
                                                onChange={(selected) => {
                                                    setValue("pattern_type", selected ? selected.id : '');
                                                    trigger("pattern_type");
                                                    setSettingPatternTypeItems(selected ? selected.items : []);
                                                    setValue("main_print_type", '');
                                                    trigger("main_print_type");
                                                }}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("pattern_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.pattern_type?.message}</div>
                                        </FormGroup>
                                    </Col>

                                    <Col md="3">
                                    {/* Main Print Type (single select, conditional) */}
                                    {(getValues("pattern_type") && settingPatternTypeItems.length > 0) && (
                                        <FormGroup>
                                            <Label className="form-label">Main Print Type</Label>
                                            <Select
                                                placeholder="Select Main Print Type"
                                                isDisabled={disabledInputs.main_print_type}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                getOptionValue={(option) => option.id}
                                                getOptionLabel={(option) => option.name}
                                                options={settingPatternTypeItems}
                                                className={errors.main_print_type ? "is-invalid" : ""}
                                                value={settingPatternTypeItems.find(opt => opt.id === (getValues("main_print_type") || '')) || null}
                                                onChange={(selected) => {
                                                    setValue("main_print_type", selected ? selected.id : '');
                                                    trigger("main_print_type");
                                                }}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("main_print_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.pattern_type?.message}</div>
                                        </FormGroup>
                                    )}
                                    </Col>

                                    <Col md="3">                    
                                    </Col>
                                </Row>
                                <hr />
                                
                                <Row>
                                    <Col>
                                        <ColourTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            disabledInputs={disabledInputs}
                                            settingColours={settingColours}
                                            settingMainSolidColours={settingMainSolidColours}
                                            settingColourFamilies={settingColourFamilies}
                                            colourRows={colourRows}
                                            setColourRows={setColourRows}
                                        />
                                    </Col>
                                </Row>
                                <hr />

                                {/* Additional Product Info - First Row */}                                
                                <Label className="form-label ai-form-heading">Additional Product Details</Label>
                                <Row>
                                    {/* Product Type (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Product Type</Label>
                                            <Select
                                                placeholder="Select Product Type"
                                                options={settingProductTypes || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingProductTypes?.find(opt => opt.id === getValues("product_type")) || null}
                                                onChange={selected => { 
                                                    setValue("product_type", selected ? selected.id : ''); 
                                                    trigger("product_type"); 
                                                    setValue("product_category", ''); // Reset category when type changes
                                                    trigger("product_category");
                                                    setValue("product_sub_category", ''); // Reset sub category when type changes
                                                    trigger("product_sub_category");
                                                    setValue("styles", []); // Reset styles when type changes
                                                    trigger("styles");
                                                }}
                                                className={errors.product_type ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("product_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.product_type?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Product Category (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Product Category</Label>
                                            <Select
                                                placeholder="Select Product Category"
                                                options={settingProductCategories?.filter(opt => opt.type_id === getValues("product_type")) || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingProductCategories?.find(opt => opt.id === getValues("product_category")) || null}
                                                onChange={selected => { 
                                                    const categoryId = selected ? selected.id : '';

                                                    setValue("product_category", categoryId); 
                                                    trigger("product_category"); 

                                                    // Apply Dress Length rule
                                                    applyDressLengthRule(categoryId);

                                                    setValue("product_sub_category", ''); // Reset sub category when category changes
                                                    trigger("product_sub_category");
                                                    setSettingCatStyles(settingStyles?.filter(opt => opt.category_id === (categoryId || '')) || []);
                                                    setValue("styles", []); // Reset styles when category changes
                                                    trigger("styles");
                                                }}
                                                className={errors.product_category ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("product_category") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.product_category?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Product Sub Category (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Product Sub Category</Label>
                                            <Select
                                                placeholder="Select Product Sub Category"
                                                options={settingProductSubCategories?.filter(opt => opt.category_id === getValues("product_category")) || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingProductSubCategories?.find(opt => opt.id === getValues("product_sub_category")) || null}
                                                onChange={selected => { 
                                                    setValue("product_sub_category", selected ? selected.id : ''); 
                                                    trigger("product_sub_category"); 
                                                    setValue("styles", []); // Reset styles when sub category changes
                                                    trigger("styles");
                                                }}
                                                className={errors.product_sub_category ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("product_sub_category") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.product_sub_category?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Styles (Multi Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Styles</Label>
                                            <Select
                                                placeholder="Select Styles"
                                                isMulti
                                                options={settingCatStyles?.filter(opt => opt.category_id === getValues("product_category")) || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingCatStyles?.filter(opt => (getValues("styles") || []).includes(opt.id))}
                                                onChange={selected => { setValue("styles", selected ? selected.map(s => s.id) : []); trigger("styles"); }}
                                                className={errors.styles ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("styles") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.styles?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Special Features (Multi Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Special Features</Label>
                                            <Select
                                                placeholder="Select Special Features"
                                                isMulti
                                                options={settingSpecialFeatures || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingSpecialFeatures?.filter(opt => (getValues("special_features") || []).includes(opt.id))}
                                                onChange={selected => { setValue("special_features", selected ? selected.map(s => s.id) : []); trigger("special_features"); }}
                                                className={errors.special_features ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("special_features") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.special_features?.message}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {/* Additional Product Info - Secound Row */}
                                <Row>
                                    {/* Dress Length (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Dress Length</Label>
                                            <Select
                                                placeholder="Select Dress Length"
                                                isDisabled={isDressLengthDisabled}
                                                options={settingDressLengths || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingDressLengths?.find(opt => opt.id === getValues("dress_length")) || null}
                                                onChange={selected => { setValue("dress_length", selected ? selected.id : ''); trigger("dress_length"); }}
                                                className={errors.dress_length ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("dress_length") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.dress_length?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Sleeve Type (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Sleeve Type</Label>
                                            <Select
                                                placeholder="Select Sleeve Type"
                                                options={settingSleeveTypes || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingSleeveTypes?.find(opt => opt.id === getValues("sleeve_type")) || null}
                                                onChange={selected => { setValue("sleeve_type", selected ? selected.id : ''); trigger("sleeve_type"); }}
                                                className={errors.sleeve_type ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("sleeve_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.sleeve_type?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Sleeve Length (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Sleeve Length</Label>
                                            <Select
                                                placeholder="Select Sleeve Length"
                                                options={settingSleeveLengths || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingSleeveLengths?.find(opt => opt.id === getValues("sleeve_length")) || null}
                                                onChange={selected => { setValue("sleeve_length", selected ? selected.id : ''); trigger("sleeve_length"); }}
                                                className={errors.sleeve_length ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("sleeve_length") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.sleeve_length?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Neck Type (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Neck Type</Label>
                                            <Select
                                                placeholder="Select Neck Type"
                                                isMulti
                                                options={settingNeckTypes || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingNeckTypes?.filter(opt => (getValues("neck_type") || []).includes(opt.id))}
                                                onChange={selected => { setValue("neck_type", selected ? selected.map(s => s.id) : []); trigger("neck_type"); }}
                                                className={errors.neck_type ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("neck_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.neck_type?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Hem Type (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Hem Type</Label>
                                            <Select
                                                placeholder="Select Hem Type"
                                                isMulti
                                                options={settingHemTypes || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingHemTypes?.filter(opt => (getValues("hem_type") || []).includes(opt.id))}
                                                onChange={selected => { setValue("hem_type", selected ? selected.map(s => s.id) : []); trigger("hem_type"); }}
                                                className={errors.hem_type ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("hem_type") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.hem_type?.message}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {/* Additional Product Info - Third Row */}
                                <Row>
                                    {/* Season (Multi Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Season</Label>
                                            <Select
                                                placeholder="Select Season"
                                                isMulti
                                                options={settingSeasons || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingSeasons?.filter(opt => (getValues("seasons") || []).includes(opt.id))}
                                                onChange={selected => { setValue("seasons", selected ? selected.map(s => s.id) : []); trigger("seasons"); }}
                                                className={errors.seasons ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("seasons") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.seasons?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* About The Fit (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">About The Fit</Label>
                                            <Select
                                                placeholder="Select About The Fit"
                                                isMulti
                                                options={settingAboutTheFits || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingAboutTheFits?.filter(opt => (getValues("about_the_fits") || []).includes(opt.id))}
                                                onChange={selected => { setValue("about_the_fits", selected ? selected.map(s => s.id) : []); trigger("about_the_fits"); }}
                                                className={errors.about_the_fits ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return (getValues("about_the_fits") || []).length ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.about_the_fits?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Whether True to Size (Single Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Whether True to Size</Label>
                                            <Select
                                                placeholder="Select True to Size"
                                                options={settingTrueToSizeOptions || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingTrueToSizeOptions?.find(opt => opt.id === getValues("true_to_size")) || null}
                                                onChange={selected => { setValue("true_to_size", selected ? selected.id : ''); trigger("true_to_size"); }}
                                                className={errors.true_to_size ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("true_to_size") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.true_to_size?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Sustainability Info (Multi Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Sustainability Info</Label>
                                            <Select
                                                placeholder="Select Sustainability Info"
                                                isMulti
                                                options={settingSustainabilityInfo || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingSustainabilityInfo?.filter(opt => (getValues("sustainability_records") || []).includes(opt.id))}
                                                onChange={selected => { setValue("sustainability_records", selected ? selected.map(s => s.id) : []); trigger("sustainability_records"); }}
                                                className={errors.sustainability_records ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("sustainability_records") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.sustainability_records?.message}</div>
                                        </FormGroup>
                                    </Col>
                                    {/* Commodity (Multi Select) */}
                                    <Col md="">
                                        <FormGroup>
                                            <Label className="form-label">Commodity</Label>
                                            <Select
                                                placeholder="Select Commodity"
                                                isMulti
                                                options={settingCommodities || []}
                                                getOptionValue={option => option.id}
                                                getOptionLabel={option => option.name}
                                                value={settingCommodities?.filter(opt => (getValues("commodities") || []).includes(opt.id))}
                                                onChange={selected => { setValue("commodities", selected ? selected.map(s => s.id) : []); trigger("commodities"); }}
                                                className={errors.commodities ? "is-invalid" : ""}
                                                isClearable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: (props) => {
                                                        return getValues("commodities") ? null : <components.DropdownIndicator {...props} />;
                                                    }
                                                }}
                                            />
                                            <div className="invalid-feedback">{errors.commodities?.message}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {/* Occassion Table Section */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <OccassionTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingOccassions={settingOccassions}
                                            settingSubOccassions={settingSubOccassions}
                                            occassionRows={occassionRows}
                                            setOccassionRows={setOccassionRows}
                                        />
                                    </Col>
                                </Row>

                                <hr />
                                <Row>
                                    {/* Available Colour Section */}
                                    <Col md="6">
                                        <AvailableColour
                                            getValues={getValues}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                        />
                                    </Col>
                                    {/* Available Difference Fabric Section */}
                                    <Col md="6">
                                        <AvailableDifferenceFabric
                                            getValues={getValues}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                        />
                                    </Col>
                                </Row>

                                {/* Also Available in Length Table Format */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <AvailableIn
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingAvailableInTypes={settingAvailableInTypes}
                                            availableInRows={availableInRows}
                                            setAvailableInRows={setAvailableInRows}
                                        />
                                    </Col>
                                </Row>

                                {/* Also Available in Length Table Format */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <AvailableLengthTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingAvailableLengthTypes={settingAvailableLengthTypes}
                                            availableLengthRows={availableLengthRows}
                                            setAvailableLengthRows={setAvailableLengthRows}
                                        />
                                    </Col>
                                </Row>

                                {/* Also Available in Fit Table Format */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <AvailableFitTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingAvailableFitTypes={settingAvailableFitTypes}
                                            availableFitRows={availableFitRows}
                                            setAvailableFitRows={setAvailableFitRows}
                                        />
                                    </Col>
                                </Row>

                                {/* Fabric Table Section */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <FabricTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingFabricTypes={settingFabricTypes}
                                            settingMainFabrics={settingMainFabrics}
                                            settingSubFabrics={settingSubFabrics}
                                            settingCompositions={settingCompositions}
                                            fabricRows={fabricRows}
                                            setFabricRows={setFabricRows}
                                        />
                                    </Col>
                                </Row>

                                {/* Trimmings Table Section */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <TrimmingsTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingTrimmings={settingTrimmings}
                                            settingSubTrimmings={settingSubTrimmings}
                                            trimmingRows={trimmingRows}
                                            setTrimmingRows={setTrimmingRows}
                                        />
                                    </Col>
                                </Row>

                                {/* Wash Care Table Section */}
                                <hr />
                                <Row>
                                    <Col md="12">
                                        <WashCareTable
                                            setValue={setValue}
                                            trigger={trigger}
                                            settingWashCares={settingWashCares}
                                            settingSubWashCares={settingSubWashCares}
                                            washCareRows={washCareRows}
                                            setWashCareRows={setWashCareRows}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </ModalBody>}


                {!loading && <ModalFooter>
                    <Button type="button" color="secondary" onClick={() => closDialog()} disabled={formBtnDisable()}>Cancel</Button>
                    <Button type="submit" color="primary" form="productAIForm"
                        disabled={formBtnDisable() || !formState.isValid || fabricsHasDuplicates || trimmingsHasDuplicates || washCaresHasDuplicates || availableInDuplicates || availableInDuplicates || availableLengthsHasDuplicates || availableFitDuplicates}>
                        {submitBtnDisable && <i className="fa fa-spinner fa-lg spinner mr-1" />} Submit
                     </Button>
                 </ModalFooter>}
            </Modal>

            {/* Image popup for header image with navigation */}
            {isImagePopupOpen && productImages && productImages.length > 0 && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 2000, background: 'rgba(0,0,0,0.7)' }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                        <img
                            src={productImages[popupImageIndex].url}
                            alt={productImages[popupImageIndex].alt_text}
                            style={{ maxWidth: '80vw', maxHeight: '80vh', borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.3)' }}
                        />
                        <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16 }}>
                            <Button
                                color="secondary"
                                onClick={() => setPopupImageIndex((popupImageIndex - 1 + productImages.length) % productImages.length)}
                                disabled={productImages.length <= 1}
                            >
                                Prev
                            </Button>
                            <Button color="secondary" onClick={() => setIsImagePopupOpen(false)}>Close</Button>
                            <Button
                                color="secondary"
                                onClick={() => setPopupImageIndex((popupImageIndex + 1) % productImages.length)}
                                disabled={productImages.length <= 1}
                            >
                                Next
                            </Button>
                        </div>
                        <div style={{ marginTop: 8, color: '#fff', fontSize: 14 }}>
                            {popupImageIndex + 1} / {productImages.length}
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}

export default ProductAIForm;
